import React,{useState} from 'react'

export default function DateAndTime() {

    const date = new Date().toDateString();

    const [time, setTime] = useState(date);

    const ct = ()=>{
        const currentTime = new Date().toLocaleTimeString();
        setTime(currentTime);
    }
    setInterval(ct,1000);    

    return (
        <div className="DateAndTime text-center" style={{'backgroundColor':'lightgray'}}>
            {`Date : ${date} | Time : ${time}`}
        </div>
    )
}
